import styles from './seg.module.css';

export interface SegItem<T extends string> {
  readonly value: T;
  readonly label: string;
  readonly disabled?: boolean;
}

export interface SegProps<T extends string> {
  readonly items: readonly SegItem<T>[];
  readonly value: T | null;
  readonly onChange: (value: T) => void;
  readonly ariaLabel: string;
}

/**
 * Dilimli kontrol (sekme/filtre seçimi) — Görsel Dil v2.
 * Gezinme değil bir seçim kontrolü olduğu için aktif dilim `aria-pressed` taşır
 * (README 4.9: gezinmede `aria-current`, kontrollerde `aria-pressed`).
 */
export function Seg<T extends string>({ items, value, onChange, ariaLabel }: SegProps<T>) {
  return (
    <div className={styles.seg} role="group" aria-label={ariaLabel}>
      {items.map((item) => (
        <button
          key={item.value}
          type="button"
          disabled={item.disabled}
          aria-pressed={item.value === value}
          className={[styles.item, item.value === value ? styles.active : '']
            .filter(Boolean)
            .join(' ')}
          onClick={() => onChange(item.value)}
        >
          {item.label}
        </button>
      ))}
    </div>
  );
}

export const segStyles = styles;
